const BASE_LINKS = {
  en: '/',
  es: '/es',
  it: '/it',
  fr: '/fr',
  de: '/de',
  pt: '/pt'
};

const BASE_LINK_CHINESE = {
  cn: '/cn'
};

export const getBaseLinks = ({ chinese }) => ({
  ...BASE_LINKS,
  ...(chinese ? BASE_LINK_CHINESE : {})
});

export default {
  getBaseLinks
};
